export function jamcamSvc(): string {
  return 'jamcam-svc';
}
